module.exports = __webpack_public_path__ + "img/Date.6c55a2b1.svg";